<template>
  <div class="mt-8 mx-12 w-full">
    <vue-plyr ref="plyr">
      <div :data-plyr-provider="get_provider"
           :data-plyr-embed-id="get_id"></div>
    </vue-plyr>

    <pre v-if="debug">
      {{ block }}
    </pre>
  </div>
</template>

<script>
import EventBus from '../../api/event-bus'

export default {
  name: 'Video',
  props: {
    block: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      debug: false,
      timerid: null
    }
  },
  computed: {
    random_value: () => Math.random(),
    get_id() {
      return this.block.url.split("/").pop()
    },
    get_provider() {
      if( this.block.url.match("youtu") ) {
        return 'youtube'
      } else {
        return 'vimeo'
      }
    }
  },
  mounted() {
    this.$refs.plyr.player.on('playing', (elm) => {
      EventBus.emit('send-multimedia-ping', {
        block_id: this.block.id,
        current_time: this.$refs.plyr.player.currentTime,
        duration: this.$refs.plyr.player.duration,
        speed: this.$refs.plyr.player.speed
      })
      // console.log( 'playing fired', elm,
      //              this.$refs.plyr.player.currentTime,
      //              this.$refs.plyr.player.duration,
      //              this.$refs.plyr.player.speed )
      this.timerid = setInterval(() => {
        EventBus.emit('send-multimedia-ping', {
          block_id: this.block.id,
          current_time: this.$refs.plyr.player.currentTime,
          duration: this.$refs.plyr.player.duration,
          speed: this.$refs.plyr.player.speed
        })
        // console.log( 'still playing',
        //              this.$refs.plyr.player.currentTime,
        //              this.$refs.plyr.player.duration,
        //              this.$refs.plyr.player.speed )
      }, 1000 )
    })
    this.$refs.plyr.player.on('pause', (elm) => {
      // console.log( 'pause fired', elm, elm.currentTime, elm.duration )
      clearInterval( this.timerid )
    })
  },
  unmounted() {
    // console.log( 'unmount' )
    if( this.timerid > 0 ) {
      clearInterval( this.timerid )
    }
  },

}
</script>